/**
 * Implements a router
 */
import {
  createBrowserRouter,
  createRoutesFromElements,
  generatePath,
  Navigate,
  Route,
  RouterProvider,
} from 'react-router-dom';
import TVChartPage from './pages/TVChartPage';
import MainPage from './pages/MainPage';
import NewPairsPage from './pages/NewPairsPage';
import BigTradesPage from './pages/BigTradesPage';
import TokenPage from './pages/TokenPage';
import ChainPage from './pages/ChainPage';
import {
  tokenPageLoader,
  bigTradesPageLoader,
  newPairsPageLoader,
  cexCurrentLoader,
  dexCurrentLoader,
  directSwapsLoader,
  chainPageLoader,
} from './pages/loaders';
import DirectSwapPage from './pages/DirectSwap';
import useCacheBuster from './hooks/useCacheBuster';

const JSXRouter = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path='/embed/tvchart/:chain/:address' element={<TVChartPage />} />
      <Route
        path='/top-traders/:chain/:address/:wallet/:timeframe'
        element={<MainPage />}
      />
      <Route path='/wallet/:wallet/:timeframe' element={<MainPage />} />
      <Route
        path='/:exchange/:base/:quote'
        element={<MainPage />}
        loader={cexCurrentLoader}
      />
      <Route
        path='/:chain/:address'
        element={<MainPage />}
        loader={dexCurrentLoader}
      />
      <Route
        path='/swap/:chain/:src/:dest'
        element={<DirectSwapPage />}
        loader={directSwapsLoader}
      />
      <Route
        path='/new-pairs'
        element={<NewPairsPage />}
        loader={newPairsPageLoader}
      />
      <Route
        path='/big-trades'
        element={<BigTradesPage />}
        loader={bigTradesPageLoader}
      />
      <Route
        path='/:lang/token/:chain/:address'
        element={<TokenPage />}
        loader={tokenPageLoader}
      />
      <Route
        path='/:lang/chain/:chain'
        element={<ChainPage />}
        loader={chainPageLoader}
      />
      <Route
        path='/dev'
        element={
          <div
            className='centrify'
            style={{ backgroundColor: 'var(--grey-700)' }}
          ></div>
        }
      />
      <Route
        path='*'
        element={
          <Navigate to='/ETH/0x92dBB765f587F6E16C07C799E0dB6A1f3AF498B8' />
        }
      />
    </>
  )
);

const AuthLogic = () => {
  useCacheBuster();

  return <RouterProvider router={JSXRouter} />;
};

export const switchCurrentTicker = (payload: any) => {
  const currentRoute = JSXRouter.state.matches[0];
  const currentRoutePattern = currentRoute.route.path || '';
  const tickerRoutes = [
    '/:exchange/:base/:quote',
    '/:chain/:address',
    '/wallet/:wallet/:timeframe',
    '/top-traders/:chain/:address/:wallet/:timeframe',
    '/:lang/token/:chain/:address',
    '/:lang/chain/:chain',
  ];
  const currentParams = currentRoute.params;
  const [newBase, newQuote] = payload.name.split('/');

  let newUrl = '';
  if (tickerRoutes.includes(currentRoutePattern)) {
    newUrl = payload.address
      ? `/${payload.chain}/${payload.address}`
      : `/${payload.exchange}/${newBase}/${newQuote}`;
  } else {
    let newParams = currentParams;
    const { chain, address, base, quote, exchange, ...restParams } =
      currentParams;
    if (address && chain) {
      newParams = { address: payload.address, chain: payload.chain };
    } else if (base && quote && exchange) {
      newParams = {
        exchange: payload.exchange,
        base: newBase,
        quote: newQuote,
      };
    }
    newUrl = generatePath(currentRoutePattern, {
      ...newParams,
      ...restParams,
    });
  }

  return JSXRouter.navigate(newUrl);
};

export default AuthLogic;
